import SpainA3innuvaJobPosition from 'modules/contracts/store/models/SpainA3innuvaJobPosition'

import { PayrollLegalEntityResource } from 'modules/contracts/store/collections/payrollLegalEntityResource'

class A3innuvaJobPositions extends PayrollLegalEntityResource<SpainA3innuvaJobPosition> {
  get cacheKey(): string {
    return 'a3innuvaJobPositions'
  }

  model() {
    return SpainA3innuvaJobPosition
  }

  fetchByLegalEntityIds(legalEntityIds: number[]) {
    this.fetch({ data: { legal_entity_ids: legalEntityIds } })
  }

  /**
   * @override
   * The PayrollLegalEntityResource class has a computed property called actives
   * that filters the resources by the isActive property. This property is not
   * present in the A3innuvaJobPositions model, so we override the actives property
   */
  get actives() {
    return this.models
  }
}

export { A3innuvaJobPositions }
